// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nBZ40CVyDtqS8N {
  position: relative;
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-radius-small, 3px);
  text-align: center;
}
.nBZ40CVyDtqS8N .FICEr3Pah_tuJG {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-250, 18px);
  margin-bottom: var(--ds-space-0, 0);
}
.nBZ40CVyDtqS8N .Vm5E5nyBXyM8qk {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
.nBZ40CVyDtqS8N .wtOG0sS0J7wESU {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  margin-top: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-0, 0px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  text-align: center;
}
.nBZ40CVyDtqS8N .wtOG0sS0J7wESU strong {
  width: 100%;
}
.nBZ40CVyDtqS8N .Nzcn5rqWq0OKwG {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-bottom: var(--ds-space-200, 16px);
  font-size: 12px;
  line-height: 16px;
}
.nBZ40CVyDtqS8N .c4V623BqQ6lMNh {
  margin-bottom: var(--ds-space-200, 16px);
}
.nBZ40CVyDtqS8N .c4V623BqQ6lMNh .N5aobqNZjJHanD {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.nBZ40CVyDtqS8N .c4V623BqQ6lMNh .onO3lIyRgyZVAI,
.nBZ40CVyDtqS8N .c4V623BqQ6lMNh .Y8j511wAPLq66v {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.nBZ40CVyDtqS8N .VTiP8qgqr9__wb {
  margin-bottom: var(--ds-space-200, 16px);
}
.nBZ40CVyDtqS8N .VTiP8qgqr9__wb .vUP_ydEJoBL3zP {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.nBZ40CVyDtqS8N ._5em1YBYOA4iRKJ {
  display: grid;
  height: 70px;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 15px);
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
.nBZ40CVyDtqS8N ._5em1YBYOA4iRKJ p {
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 450px) {
  .nBZ40CVyDtqS8N {
    width: 265px;
  }
}
`, ""]);
// Exports
export var planCard = `nBZ40CVyDtqS8N`;
export var name = `FICEr3Pah_tuJG`;
export var info = `Vm5E5nyBXyM8qk`;
export var infoHeading = `wtOG0sS0J7wESU`;
export var infoBody = `Nzcn5rqWq0OKwG`;
export var priceContainer = `c4V623BqQ6lMNh`;
export var price = `N5aobqNZjJHanD`;
export var frequency = `onO3lIyRgyZVAI`;
export var pricingVaries = `Y8j511wAPLq66v`;
export var ctaContainer = `VTiP8qgqr9__wb`;
export var currentPlan = `vUP_ydEJoBL3zP`;
export var enterpriseFooter = `_5em1YBYOA4iRKJ`;
export default ___CSS_LOADER_EXPORT___;
